module.exports = __webpack_public_path__ + "static/media/gif_active.629a168e.svg";